// extracted by mini-css-extract-plugin
export default {"title":"Title_title__Ss+NU","title_1":"Title_title_1__IVzro","title_2":"Title_title_2__Axh-T","title_3":"Title_title_3__O7In3"};